import { Trans, useLingui } from "@lingui/react/macro";
import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import { ExternalLinkIcon } from "@offstreetparking/design-system/icons/ExternalLinkIcon";
import { LocationIcon } from "@offstreetparking/design-system/icons/LocationIcon";
import { Text } from "@offstreetparking/design-system/typography";
import Image from "next/image";
import { useKiosk } from "../../providers/KioskProvider";
import { ViewMap } from "../ViewMap";
import { getLocalizedLargestDurationString } from "./getLocalizedLargestDurationString";
export const ParkingLocationsRow = ({
	lot,
	name,
	showDirectionsLink,
}: {
	lot?: {
		centerLat?: string;
		centerLng?: string;
		addressLineOne?: string;
		addressLineTwo?: string;
		city?: string;
		state?: string;
		country?: string;
		postalCode?: string;
		useAddress?: boolean;
		name: string;
		distancesFromPlaces?: {
			originId: string;
			timeSeconds: number;
			distanceMeters: number;
		};
	};
	name: string;
	showDirectionsLink: boolean;
}) => {
	const { isKiosk } = useKiosk();
	const { i18n, t } = useLingui();
	const seconds = lot?.distancesFromPlaces?.timeSeconds ?? 0;
	const localizedDuration = getLocalizedLargestDurationString(seconds, i18n);
	return (
		<>
			<div className="flex items-center gap-2">
				<AccessibleIcon>
					<LocationIcon className="h-4 w-4" />
				</AccessibleIcon>
				<Text size="sm">{name}</Text>
			</div>
			<div className="ml-6 flex">
				{showDirectionsLink &&
					lot &&
					(isKiosk ? (
						lot.distancesFromPlaces && (
							<div className="flex items-center gap-1 text-sm">
								<div className="h-1 w-1 rounded-full bg-divider" />

								<Image
									src="https://offstreet.s3.us-west-2.amazonaws.com/icons/walking.svg"
									alt=""
									width={22}
									height={22}
									sizes="22px"
								/>
								<span className="text-sm">
									<Trans>{localizedDuration} to venue</Trans>
								</span>
							</div>
						)
					) : (
						<ViewMap place={lot} aria-label={`${t`Directions`} ${t`(opens in a new tab)`}`}>
							<div className="flex items-center gap-2">
								<Text As="span" size="sm" className="link">
									{t`Directions`}

									<span>
										<ExternalLinkIcon className="ml-0.5 inline h-3 w-3" />
									</span>
								</Text>
								{lot.distancesFromPlaces && (
									<div className="flex items-center gap-1 text-sm">
										<div className="h-1 w-1 rounded-full bg-divider" />

										<Image
											src="https://offstreet.s3.us-west-2.amazonaws.com/icons/walking.svg"
											alt=""
											width={22}
											height={22}
											sizes="22px"
										/>
										<span className="text-sm">
											<Trans>{localizedDuration} to venue</Trans>
										</span>
									</div>
								)}
							</div>
						</ViewMap>
					))}
			</div>
		</>
	);
};
